import type { Dict, Language } from "./types";
import { publicBooking } from "./booking/public-booking";
import { clientPortal } from "./booking/client-portal";
import { calendar } from "./owner/calendar";
import { salonInfo } from "./owner/salon-info";
import { openingHours } from "./owner/opening-hours";
import { roomsEquipment } from "./owner/rooms-equipment";
import { services } from "./owner/services";
import { personnel } from "./owner/personnel";
import { clients } from "./owner/clients";
import { marketing } from "./owner/marketing";
import { giftCards } from "./owner/gift-cards";
import { workShifts } from "./owner/work-shifts";
import { payroll } from "./owner/payroll";
import { invoicing } from "./owner/invoicing";
import { payments } from "./owner/payments";
import { inventory } from "./owner/inventory";
import { reports } from "./owner/reports";
import { activityLog } from "./owner/activity-log";
import { ai } from "./owner/ai";
import { permissions } from "./owner/permissions";
import { subscription } from "./owner/subscription";
import { announcements } from "./owner/announcements";
import { dashboardShell } from "./owner/dashboard-shell";
import { admin } from "./admin/admin";
import { auth } from "./shared/auth";
import { common } from "./shared/common";
import { dataTable } from "./shared/data-table";
import { publicPages } from "./shared/public-pages";

/**
 * Les 28 modules du dictionnaire, rangés par domaine. L'ordre n'a aucune
 * importance : leurs ensembles de clés sont disjoints, c'est vérifié par
 * src/contexts/__tests__/i18nKeyParity.test.ts.
 */
const MODULES: Dict[] = [
  publicBooking,
  clientPortal,
  calendar,
  salonInfo,
  openingHours,
  roomsEquipment,
  services,
  personnel,
  clients,
  marketing,
  giftCards,
  workShifts,
  payroll,
  invoicing,
  payments,
  inventory,
  reports,
  activityLog,
  ai,
  permissions,
  subscription,
  announcements,
  dashboardShell,
  admin,
  auth,
  common,
  dataTable,
  publicPages,
];

function merge(language: Language): Record<string, string> {
  const out: Record<string, string> = {};
  for (const module of MODULES) {
    for (const [key, value] of Object.entries(module[language])) {
      if (import.meta.env?.DEV && key in out) {
        // Deux modules définissent la même clé : la seconde écrase la première
        // en silence. Le test de disjonction attrape ça en CI, ce garde fou
        // sert au développeur qui vient de l'introduire.
        console.error(`[i18n] clé définie deux fois : ${key} (${language})`);
      }
      out[key] = value;
    }
  }
  return out;
}

export const translations = {
  en: merge("en"),
  fr: merge("fr"),
};
